"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _styles = require("@mui/material/styles");
var HiDownload = (0, _pure.default)(function (props) {
  var theme = (0, _styles.useTheme)();
  var _props$color = props.color,
    color = _props$color === void 0 ? props.color || theme.palette.neutral.main : _props$color,
    style = props.style,
    other = (0, _objectWithoutProperties2.default)(props, ["color", "style"]);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    style: (0, _objectSpread2.default)({}, style, {
      fontSize: props.size || 24
    })
  }, other), /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 500 500"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "M250 0C111.94 0 0 111.94 0 250s111.92 250 250 250 250-111.92 250-250S388.06 0 250 0zm-44.18 210.14V114.8h88.37v95.34h58.68L250 321.14l-102.87-111zM352.87 385.2H147.13v-32h205.74z"
  })));
});
HiDownload.muiName = 'SvgIcon';
var _default = exports.default = HiDownload;